import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 0;
  max-height: 70vh;
  overflow-y: auto;
  width: 100%;

  &::-webkit-scrollbar-track {
    background: #ffffff;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #6f777c;
    border-radius: 10px;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }
`

export const InnerWrapper = styled.div`
  background-color: ${({ theme }) => theme.color.background.main};
`

export const StyledContent = styled.pre`
  display: flex;
  height: 100%;
  max-height: 650px;
  overflow-y: auto;
  width: 100%;

  iframe {
    border: 0;
    height: 70vh;
    width: 100%;
  }
`

export const StyledImage = styled.img`
  display: block;
  max-height: 70vh;
  max-width: 100%;
  object-fit: contain;
  width: 100%;
`

export const TextFileContent = styled.div`
  width: 100%;
`

export const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  width: 100%;
`

export const PreviewModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  min-height: 300px;
  width: 100%;
`

export const DocxFilePreview = styled.div`
  min-height: 400px;
`
